import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/admin/services/customer/customer.service';
import { OrderServiceService } from 'src/app/admin/services/orders/order-service.service';

@Component({
    selector: 'app-list-promo-orders',
    templateUrl: './list-promo-orders.component.html',
    styleUrls: ['./list-promo-orders.component.scss'],
    standalone: false
})
export class ListPromoOrdersComponent implements OnInit {

  constructor(
    private order: OrderServiceService,
    private spinner: NgxSpinnerService,
    private customerService: CustomerService,
    private toast: ToastrService
  ) { }
  title = 'angular-datatables';

  orderList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.listPromoOrders()
    this.getCustomerList()
  }

  /* ***********
  list All Orders
  *********** */

  listPromoOrders() {
    this.spinner.show()
    this.order.listPromoOrders({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.orderList = res.data;
        // console.log(this.orderList)
        this.temp = this.orderList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter(function (d: any) {

      return d.customerId?.name.toLowerCase().indexOf(val) !== -1 || !val ||
        d.orderpromoId.toString().indexOf(val) !== -1 || !val ||
        d.astroId?.displayname.toLowerCase().indexOf(val) !== -1 ||
        d.astroId?.astroAutoId.toString().indexOf(val) !== -1 ||
        d.customerId?.customerAutoId.toString().indexOf(val) !== -1 ||
        d.customerId?.name.toLowerCase().indexOf(val) !== -1 || !val
    });

    // update the rows
    this.orderList = temp;
    // Whenever the filter changes, always go back to the first page
    this.myFilterTable.offset = 0;
  }

  customerList:any = []
  getCustomerList(){
    this.customerService.getCustomersList({}).subscribe(
      (res:any) =>{
        this.customerList = res.data
      }
    )
  }

  getOrderByCustomerId(event:any){
    if(event.target.value == ""){
      this.listPromoOrders()
    }else{
      this.spinner.show()
      this.order.listPromoOrders({customerId:event.target.value}).subscribe(
        (res: any) => {
          this.spinner.hide()
          this.orderList = res.data;
          //console.log(this.orderList)
          this.temp = this.orderList;
        },
        (err) => {
          this.spinner.hide()
          //console.log(err);
        }
      );
    }
  }
  getOrderByCustomerIdV2(event:any){
    if(event == ""){
      this.listPromoOrders()
    }else{
      this.spinner.show()
      this.order.listPromoOrders({customerId:event}).subscribe(
        (res: any) => {
          this.spinner.hide()
          this.orderList = res.data;
          //console.log(this.orderList)
          this.temp = this.orderList;
        },
        (err) => {
          this.spinner.hide()
          //console.log(err);
        }
      );
    }
  }

  cancelPromo(id:any){
    this.spinner.show()
    this.order.updatePromoOrders({promoId:id,status:false}).subscribe(
      (res:any) =>{
        this.spinner.hide()
        this.listPromoOrders()
      },err=>{
        this.spinner.hide()
        this.toast.error(err.error.message,'error')
      }
    )
  }
  connectPromo(id:any){
    this.spinner.show()
    this.order.connectPromoOrders({promoId:id}).subscribe(
      (res:any) =>{
        // console.log(res)
        this.spinner.hide()
        this.toast.info(res.message,'Message')
        this.listPromoOrders()
      },err=>{
        this.spinner.hide()
        this.toast.info(err.error.message,'Message')
      }
    )
  }

}
